import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { ButtonElement } from "@/react/types/Element";

import { defaultData } from "./FormButtonBlockDefaultData";

// Converts a button element to a FormButtonBlock
export const elementToBlock = (element: ButtonElement): BaseBlock => {
  const styles = element.attributes.styles || {};
  const defaultStyles = defaultData.props.styles?.value || {};

  return {
    id: element.id.toString(),
    type: "FormButtonBlock",
    props: {
      label: {
        prop: "other",
        type: "string",
        value: element.attributes.label,
      },
      styles: {
        prop: "styles",
        type: "styles",
        value: {
          ...defaultStyles,
          ...styles,
        },
      },
    },
    meta: {
      elementType: "button",
      elementId: element.id,
      elementableId: element.elementable_id,
      position: element.position,
      parentElementId: element.parent_element_id,
    },
  };
};
